import React, { useState, useEffect, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { DataGrid } from '@mui/x-data-grid';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Link } from '@mui/material';
import { getMedRepsApproved } from '../../../api/approvalsApi';
import CWPContext from '../useCWPContext';

export default function ApprovedMedRepList({ selectedDate, selectedMedRepId, onClickSpecialist }) {
  const { reloadTable, activeTab } = useContext(CWPContext);
  const [tableData, setTableData] = useState({
    data: [],
    totalRows: 0,
    loading: false,
  });

  const loadMedReps = async () => {
    try {
      setTableData({ ...tableData, data: [], loading: true });

      const res = await getMedRepsApproved({
        date: moment(selectedDate).format('YYYY-MM'),
        rep_id: selectedMedRepId,
      });

      const { success, data, totalRows, message } = res.data;

      if (!success) {
        toast.error(message);
        return;
      }

      setTableData({
        ...tableData,
        data,
        totalRows,
        loading: false,
      });
    } catch (error) {
      setTableData({ ...tableData, data: [], totalRows: 0, loading: false });
      toast.error(error.message);
    }
  };

  useEffect(() => {
    loadMedReps();
  }, [selectedDate, selectedMedRepId]);

  useEffect(() => {
    if (reloadTable.approved && activeTab === 1) {
      loadMedReps();
    }
  }, [reloadTable.approved, activeTab]);

  const handleOnClickSpecialist = (row) => {
    onClickSpecialist(row);
  };

  const columns = useMemo(
    () => [
      {
        field: 'label',
        headerName: 'Specialist',
        flex: 1,
        renderCell: ({ row }) => (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <Link onClick={() => handleOnClickSpecialist(row)} sx={{ cursor: 'pointer' }}>
            {row.label}
          </Link>
        ),
      },
      {
        field: 'timestamp',
        headerName: 'Date Submitted',
        flex: 1,
        minWidth: 150,
      },
      {
        field: 'date_approved',
        headerName: 'Date Approved',
        flex: 1,
        minWidth: 150,
      },
    ],
    [],
  );

  return (
    <div style={{ height: '550px' }} className='wahehi-dsad'>
      <DataGrid
        rows={tableData.data}
        loading={tableData.loading}
        rowCount={tableData.totalRows}
        columns={columns}
        pageSize={50}
        disableSelectionOnClick
      />
    </div>
  );
}

ApprovedMedRepList.defaultProps = {
  selectedMedRepId: '',
  onClickSpecialist: () => {},
};

ApprovedMedRepList.propTypes = {
  selectedDate: PropTypes.string.isRequired,
  selectedMedRepId: PropTypes.string,
  onClickSpecialist: PropTypes.func,
};
